import { FAIcon, useTranslation, useSession, GenericLink } from '@nextgen-web-framework/all';
import { formatNumber } from '@nextgen-web-framework/core';
import SkeletonLoader from '../SkeletonLoader/SkeletonLoader';
import styles from './AccountOffersAndPoints.module.scss';
import { AccountOffersAndPointsProps, AccountOffersWrapperConfig } from './types/propsTypes';

const accountOfferWrapper = ({ value, iconName, text, link, isLoaded }: AccountOffersWrapperConfig) => (
  <GenericLink href={link} forceNative={false} key={iconName} className={styles['accounts-offer-text-container']}>
    <div className={styles['accounts-offer-content']}>
      <div className={styles['accounts-offer-left-wrapper']}>
        <span className={styles['accounts-offer-heading']}>
          {!isLoaded ? <SkeletonLoader height={18} borderRadius={8} /> : formatNumber(value)}
        </span>
        <span className={styles['accounts-offer-text']}>{text}</span>
      </div>
      <div className={styles['accounts-offer-right-wrapper']}>
        <FAIcon iconName={iconName} className={styles['accounts-offer-icon']} />
      </div>
    </div>
  </GenericLink>
);

const AccountOffersAndPoints = ({
  couponAmt,
  voucherAmt,
  amPointsAmt,
  amPurseAmt,
  isLoaded,
}: AccountOffersAndPointsProps) => {
  const { isABO, isMember, isRegistered, isEmployee } = useSession();
  const config = ConfigService.getConfigs();
  const isVoucherAvailable = !!config.NEXT_PUBLIC_CREDIT_VOUCHER;
  const t = useTranslation();

  const registered: AccountOffersWrapperConfig[] = isVoucherAvailable
    ? [
        {
          value: couponAmt,
          iconName: 'ticket',
          text: t('web.accountOffersAndPoints.coupons'),
          link: '/coupons',
          isLoaded: isLoaded,
        },
        {
          value: voucherAmt,
          iconName: 'money-check-dollar',
          text: t('web.accountOffersAndPoints.vouchers'),
          link: '/my-account/payment-management/credit-voucher',
          isLoaded: isLoaded,
        },
      ]
    : [
        {
          value: couponAmt,
          iconName: 'ticket',
          text: t('web.accountOffersAndPoints.coupons'),
          link: '/coupons',
          isLoaded: isLoaded,
        },
      ];

  const member: AccountOffersWrapperConfig[] = [
    ...registered,
    {
      value: amPointsAmt,
      iconName: 'money-bills-simple',
      text: t('web.accountOffersAndPoints.amPoints'),
      link: '/my-account/payment-management/apoint',
      isLoaded: isLoaded,
    },
  ];

  const abo: AccountOffersWrapperConfig[] = [
    ...registered,
    {
      value: amPurseAmt,
      iconName: 'wallet',
      text: t('web.accountOffersAndPoints.amPurse'),
      link: '/my-account/payment-management/ar',
      isLoaded: isLoaded,
    },
  ];

  let accountOffersAndPoints: AccountOffersWrapperConfig[] = [];
  if (isABO()) {
    accountOffersAndPoints = abo;
  } else if (isMember()) {
    accountOffersAndPoints = member;
  } else if (isRegistered() || isEmployee()) {
    accountOffersAndPoints = registered;
  }

  return (
    <div className={styles['accounts-offer-container']} data-testid="accounts-offer-test-id">
      {accountOffersAndPoints.map((item) => accountOfferWrapper(item))}
    </div>
  );
};

export default AccountOffersAndPoints;
